"use strict";
exports.__esModule = true;
require("./index.scss");
var $ = jQuery;
$(document).ready(function () {
    $('body').on('keyup', '.agcfw-redeem-gift-card-form .gift_card_code', toggleRedeemFormButton);
    $('body').on('click', '.agcfw-redeem-gift-card-form .button', submitRedeemForm);
    initPopover();
});
function toggleRedeemFormButton() {
    // @ts-ignore
    var $input = $(this);
    var $form = $input.closest('.agcfw-redeem-gift-card-form');
    var $button = $form.find('.button');
    // disable when input has no value, enable when it has.
    $button.prop('disabled', !$input.val());
}
function submitRedeemForm() {
    var $form = $(this).closest('.agcfw-redeem-gift-card-form');
    var $giftCode = $form.find('input.gift_card_code');
    $form.find('input,button').prop('disabled', true);
    $('body').trigger('acfw-blockCheckout');
    $.post(woocommerce_params.ajax_url, {
        action: 'agcfw_redeem_gift_card',
        gift_card_code: $giftCode.val(),
        _wpnonce: $form.data('nonce'),
    }, function (response) {
        $('body').trigger('acfw-unblockCheckout');
        $(document.body).trigger('update_checkout', {
            update_shipping_method: false,
        });
    }, 'json').always(function () {
        $giftCode.val('');
        $form.find('input,button').prop('disabled', false);
    });
}
function initPopover() {
    $('.agcfw-tooltip').each(function () {
        // @ts-ignore
        $(this).webuiPopover({
            // @ts-ignore
            title: $(this).data('title'),
            // @ts-ignore
            content: $(this).data('content'),
            width: 250,
            closable: true,
            animation: 'pop',
            padding: false,
            placement: 'bottom-right',
        });
    });
}
